<template>
  <v-card
    outlined
    class="px-6 mt-6"
  >
    <div class="d-flex flex-row justify-space-between">
      <label class="subtitle-1 grey--text pb-3 pt-1 mt-4">Author</label>
    </div>
    <v-text-field
      outlined
      flat
      label="Author Name"
      v-model="authorListener"
    />

    <v-textarea
      outlined
      name="input-7-4"
      label="Author Comment"
      v-model="authorDescriptionListener"
    ></v-textarea>

    <image-file-input-viewer v-model="imageListener" />
  </v-card>
</template>

<script>
import ImageFileInputViewer from './ImageFileInputViewer'
export default {
  props: {
    author: {
      type: String,
      default: null
    },
    author_description: {
      type: String,
      default: null
    },
    author_thumbnail: {
      type: [String, Object, File],
      default () {
        return null
      }
    }
  },

  components: {
    ImageFileInputViewer
  },

  data () {
    return {
      initialImage: this.author_thumbnail
    }
  },

  computed: {
    authorListener: {
      get () {
        return this.author
      },
      set (val) {
        this.$emit('update:author', val)
      }
    },

    authorDescriptionListener: {
      get () {
        return this.author_description
      },
      set (val) {
        this.$emit('update:author_description', val)
      }
    },

    imageListener: {
      get () {
        return this.author_thumbnail
      },
      set (val) {
        if (val === null || val === undefined) {
          /**
             * Revert the value of the image to initial image
             */
          if (this.initialImage !== null) {
            val = this.initialImage
          }
        }
        this.$emit('update:author_thumbnail', val)
      }
    },

    clearable () {
      if (this.imageListener instanceof File) {
        return true
      }

      return false
    }
  }
}
</script>
